__turbopack_context__.v({
  "listening-presence": "TranscriptWorkspace-module__44fcFG__listening-presence",
  "thought-presence": "TranscriptWorkspace-module__44fcFG__thought-presence",
  "voice-presence": "TranscriptWorkspace-module__44fcFG__voice-presence",
  "workspace": "TranscriptWorkspace-module__44fcFG__workspace",
});
